<!--修改密码-->
<template>
    <el-dialog
            title="基本信息"
            :visible.sync="dialogVisible"
            width="450px"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            append-to-body>
        <el-form ref="form" :model="form" label-width="60px" @submit.prevent="submit">
            <el-form-item label="用户名">
                <div class="dec-bc-style">
                    <label>{{username}}</label>
                </div>
            </el-form-item>
            <el-form-item label="姓名">
                <el-input v-model="form.personalName" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="电话">
                <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
        </el-form>
        <div class="flex-center">
            <el-button plain @click="resetForm('form')">重置</el-button>
            <el-button plain @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
        </div>
    </el-dialog>
</template>

<script type="text/javascript">

    export default {
        name: 'EditInfoDialog',
        props: ['successCallback'],
        data() {
            return {
                dialogVisible: false,
                userId: null,
                username: '',
                form: {
                    personalName: '',
                    phone: '',
                },
            }
        },
        watch: {
            dialogVisible(newVal, oldVal) {
                if (newVal == false) {
                    Object.assign(this.$data, this.$options.data())
                } else {
                    this.username = JSON.parse(this.$store.state.userInfo).username
                    this.form = Object.assign({},JSON.parse(this.$store.state.userInfo))
                }
            }
        },
        methods: {

            // 显示弹出层
            setMaskVisible(val, data) {
                this.dialogVisible = val
                if (data && data.userId) {
                    this.userId = data.userId
                }
            },

            resetForm(formName) {
                this.form = {}
            },

            submit() {
                let params = {
                    personalName: this.form.personalName,
                    phone: this.form.phone
                }
                axios.post(Urls.URL.user_info,params).then(res => {
                    this.dialogVisible = false
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })

            }

        }
    }
</script>

<style scoped lang="stylus">
    .flex-center {
        width: 100%
        display: flex
        justify-content: center
        button {
            margin-right 5%
        }
    }

    .dec-bc-style {
        flex: 1
        background-color: #F5F5F5
        >label {
            display inline-block
            margin-left 15px
        }
    }
</style>
